import { render, staticRenderFns } from "./MultimediaGallery.vue?vue&type=template&id=1609eb7f&scoped=true"
import script from "./MultimediaGallery.vue?vue&type=script&lang=js"
export * from "./MultimediaGallery.vue?vue&type=script&lang=js"
import style0 from "./MultimediaGallery.vue?vue&type=style&index=0&id=1609eb7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1609eb7f",
  null
  
)

export default component.exports